/* ElronPrint 3D Hero v9 (2026-09-08)
   שינוי יחיד מול v8.1: התמונה תמיד ממורכזת באזור ההדפסה, והכיתוב
   יושב מעליה או מתחתיה לפי window.EPD_TXTPOS — אותו מקור שמשמש את ההדמיה
   של שלב 7 ואת קובץ ההדפסה. קודם לכן התמונה הוזזה למעלה כדי לפנות
   מקום לטקסט, והכיתוב היה תמיד מתחת.
   heavy load (three.js + image + bg-strip) starts only on first user interaction. */
(function () {
  'use strict';

  var THREE_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  var DEFAULT_SHIRT = 'https://cdn.shopify.com/s/files/1/0731/4187/8938/files/ChatGPT_Image_Jun_19_2026_05_03_26_PM.png?v=1781877823&width=900&format=pjpg';
  var SHIRT_URLS = {
    men: DEFAULT_SHIRT,
    women: 'https://cdn.shopify.com/s/files/1/0731/4187/8938/files/784cf3002e5dd105142c9aaa5912841c.png?v=1784740883&width=900&format=pjpg',
    kids: 'https://cdn.shopify.com/s/files/1/0731/4187/8938/files/c9972f75c33f8ea3d75161764972ab98.png?v=1784740883&width=900&format=pjpg'
  };
  var currentCat = 'men';
  var PRINT_FRONT = { x: 0.5, y: 0.44, w: 0.34, h: 0.34 };
  var PRINT_BACK  = { x: 0.5, y: 0.40, w: 0.40, h: 0.40 };
  var CAT_HE = { men: 'גברים', women: 'נשים', kids: 'ילדים' };

  var COLOR_MAP = {
    'white':'#f4f4f2','black':'#1d1d1f','navy':'#1f2a44','red':'#b52025','royal':'#1f4ea1',
    'sport grey':'#9ea0a3','sport gray':'#9ea0a3','graphite heather':'#5c5e62','charcoal':'#3f4143',
    'heather indigo':'#4b5a83','indigo blue':'#4b5a83','light blue':'#a3c4e0','sky':'#a3c4e0',
    'sand':'#d7cbb2','natural':'#e8e0cd','military green':'#5a5f4d','forest green':'#1f4a2e',
    'forest':'#1f4a2e','irish green':'#009a44','kelly':'#00805e','kelly green':'#00805e',
    'turf green':'#1e7a3c','purple':'#522d80','orange':'#e06b26','gold':'#eaaa00','daisy':'#f6d155',
    'yellow':'#f6d155','light pink':'#f2b8c6','pink':'#e87ea1','azalea':'#e87ea1','heliconia':'#d1327e',
    'maroon':'#6b2231','cardinal red':'#8a1e2d','dark heather grey':'#4a4c50','dark heather':'#4a4c50',
    'dark chocolate':'#3a2e2a','brown savana':'#7a6752','ash':'#e5e4e2','ice grey':'#d5d6d2',
    'heather sapphire':'#2f6f9f','sapphire':'#0f6bae','antique sapphire':'#1a6c9c','carolina blue':'#7ba4db',
    'heather royal':'#3f6ac4','heather navy':'#33405e','heather red':'#c24a58','heather grey':'#b2b4b3',
    'heather military green':'#6b705c','tennessee orange':'#e75d2a','texas orange':'#bf5b2d',
    'safety green':'#c9e94b','safety orange':'#f4633a','cornsilk':'#f2e6a7','cherry red':'#ac2b37',
    'antique cherry red':'#9b2743','berry':'#8f3f65','lime':'#92bf55','mint green':'#a7d7c5',
    'tropical blue':'#00a3c8','tahiti blue':'#00879c','jade dome':'#00a087','antique jade dome':'#008e7a',
    'galapagos blue':'#00636e','midnight':'#1f2f45','blackberry':'#31243a','russet':'#6f3b2d',
    'olive':'#5f6247','stone blue':'#6e8aa8','indigo':'#4b5a83','violet':'#7f6faf','orchid':'#b787c9',
    'coral silk':'#f4867c','sunset':'#e9743e','sky blue':'#a3c4e0','grey':'#8b8f94','gray':'#8b8f94'
  };

  var stage, renderer, scene, camera, group, clock;
  var frontMesh, backMesh, frontTex, backTex;
  var frontComp, frontCtx, backComp, backCtx;
  var baseImg = null, baseTainted = false;
  var color = '#f4f4f2';
  var frontImg = null, backImg = null, frontText = '', backText = '';
  var rotY = 0, rotX = 0, tRotY = 0, tRotX = 0;
  var dragging = false, lastPX = 0, lastPY = 0, idle = true, visible = true, running = false;
  var threeReady = false, imgReady = false, built = false;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function txtPos(side){
    var p = window.EPD_TXTPOS && window.EPD_TXTPOS[side];
    return p === 'top' ? 'top' : 'bottom';
  }

  function ready(fn){ if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn); else fn(); }

  function setSum(id,val){
    var el=document.getElementById(id); if(!el) return;
    el.textContent=(val&&String(val).trim())||'—';
  }

  function downscale(img,max){
    var w=img.naturalWidth||img.width, h=img.naturalHeight||img.height;
    if(Math.max(w,h)<=max) return img;
    var s=max/Math.max(w,h);
    var c=document.createElement('canvas');
    c.width=Math.round(w*s); c.height=Math.round(h*s);
    c.getContext('2d').drawImage(img,0,0,c.width,c.height);
    return c;
  }

  function stripShirtBg(img,tol){
    var W=img.naturalWidth||img.width, H=img.naturalHeight||img.height;
    var c=document.createElement('canvas'); c.width=W; c.height=H;
    var x=c.getContext('2d'); x.drawImage(img,0,0);
    var d;
    try{ d=x.getImageData(0,0,W,H); }
    catch(e){ baseTainted=true; return c; }
    baseTainted=false;
    var p=d.data;
    function gpx(ix,iy){ var i=(iy*W+ix)*4; return [p[i],p[i+1],p[i+2]]; }
    var cs=[gpx(2,2),gpx(W-3,2),gpx(2,H-3),gpx(W-3,H-3)];
    var br=0,bg=0,bb=0;
    for(var k=0;k<4;k++){ br+=cs[k][0]; bg+=cs[k][1]; bb+=cs[k][2]; }
    br/=4; bg/=4; bb/=4;
    var T=tol||34, T2=T*T*3;
    function dist(i){ var dr=p[i]-br,dg=p[i+1]-bg,db=p[i+2]-bb; return dr*dr+dg*dg+db*db; }
    var q=[], seen=new Uint8Array(W*H);
    function push(ix,iy){
      if(ix<0||iy<0||ix>=W||iy>=H) return;
      var n=iy*W+ix; if(seen[n]) return;
      var i=n*4; seen[n]=1;
      if(p[i+3]===0) return;
      if(dist(i)>=T2) return;
      q.push(n);
    }
    for(var ix=0;ix<W;ix++){ push(ix,0); push(ix,H-1); }
    for(var iy=0;iy<H;iy++){ push(0,iy); push(W-1,iy); }
    while(q.length){
      var n=q.pop(), cy=(n/W)|0, cx=n-cy*W, i=n*4;
      p[i+3]=0;
      var nb=[[cx+1,cy],[cx-1,cy],[cx,cy+1],[cx,cy-1]];
      for(var j=0;j<4;j++){
        var nx=nb[j][0], ny=nb[j][1];
        if(nx<0||ny<0||nx>=W||ny>=H) continue;
        var m=ny*W+nx;
        if(seen[m]) continue;
        seen[m]=1;
        var ii=m*4;
        if(p[ii+3]!==0&&dist(ii)<T2) q.push(m);
      }
    }
    x.putImageData(d,0,0);
    return c;
  }

  function isDark(css){
    var t=document.createElement('canvas'); t.width=t.height=1;
    var g=t.getContext('2d'); g.fillStyle=css; g.fillRect(0,0,1,1);
    var v=g.getImageData(0,0,1,1).data;
    return (v[0]*0.299+v[1]*0.587+v[2]*0.114)<115;
  }

  function drawSide(ctx2, canv, mirror, print, img, text, pos){
    if(!ctx2||!baseImg) return;
    var W=canv.width, H=canv.height;
    ctx2.clearRect(0,0,W,H);
    var bw=baseImg.width, bh=baseImg.height;
    var sc=Math.min(W/bw,H/bh), dw=bw*sc, dh=bh*sc, dx=(W-dw)/2, dy=(H-dh)/2;
    function paintBase(){
      ctx2.save();
      if(mirror){ ctx2.translate(W,0); ctx2.scale(-1,1); }
      ctx2.drawImage(baseImg,dx,dy,dw,dh);
      ctx2.restore();
    }
    paintBase();
    if(!baseTainted){
      ctx2.globalCompositeOperation='multiply';
      ctx2.fillStyle=color;
      ctx2.fillRect(0,0,W,H);
      ctx2.globalCompositeOperation='destination-in';
      paintBase();
      ctx2.globalCompositeOperation='source-over';
    }
    var pw=W*print.w, ph=H*print.h, px2=W*print.x, py2=H*print.y;
    var both=img&&text;
    /* התמונה תמיד במרכז אזור ההדפסה — הכיתוב לא מזיז אותה */
    if(img){
      var ih=both?ph*0.60:ph;
      var s2=Math.min(pw/img.width, ih/img.height);
      var w2=img.width*s2, h2=img.height*s2;
      ctx2.drawImage(img, px2-w2/2, py2-h2/2, w2, h2);
    }
    if(text){
      ctx2.fillStyle=isDark(color)?'#ffffff':'#141414';
      ctx2.textAlign='center'; ctx2.textBaseline='middle'; ctx2.direction='rtl';
      var lines=text.split('\n').slice(0,both?2:4);
      var size=both?ph*0.12:(lines.length>2?ph*0.16:ph*0.22);
      ctx2.font='700 '+Math.round(size)+'px Arial, sans-serif';
      var lh=size*1.22;
      var ty=both ? (pos==='top' ? py2-ph*0.40 : py2+ph*0.40) : py2;
      var y0=ty-((lines.length-1)*lh)/2;
      for(var i=0;i<lines.length;i++) ctx2.fillText(lines[i].slice(0,18), px2, y0+i*lh, pw);
    }
  }

  function redraw(){
    drawSide(frontCtx, frontComp, false, PRINT_FRONT, frontImg, frontText, txtPos('f'));
    drawSide(backCtx,  backComp,  true,  PRINT_BACK,  backImg,  backText, txtPos('b'));
    if(frontTex) frontTex.needsUpdate=true;
    if(backTex)  backTex.needsUpdate=true;
    var d=[];
    if(frontImg) d.push('תמונה קדמית');
    if(backImg) d.push('תמונה אחורית');
    if(frontText) d.push('טקסט קדמי');
    if(backText) d.push('טקסט אחורי');
    setSum('ep3s-dsg', d.join(' + '));
  }

  /* --- exposed hooks for background-removed uploads (epd-3d-bg-connect.js) --- */
  window.epd3dRedraw = function(){ if(built) redraw(); };
  window.epd3dSetDesign = function(side, img){
    if(side==='b') backImg=img; else frontImg=img;
    if(built) redraw();
  };

  function loadShirtForCat(cat){
    if(!SHIRT_URLS[cat] || cat===currentCat && built) return;
    currentCat = cat;
    var img=new Image();
    img.crossOrigin='anonymous';
    img.onload=function(){
      baseImg=stripShirtBg(downscale(img,900),34);
      imgReady=true;
      if(built) redraw(); else tryBuild();
    };
    img.onerror=function(){};
    img.src=SHIRT_URLS[cat];
  }

  function clothGeometry(w,h){
    var g=new THREE.PlaneGeometry(w,h,48,48);
    var pos=g.attributes.position;
    for(var i=0;i<pos.count;i++){
      var nx=pos.getX(i)/(w/2), ny=pos.getY(i)/(h/2);
      var z=Math.cos(nx*Math.PI*0.5)*0.40 + Math.cos(ny*Math.PI*0.5)*0.08;
      z+=Math.sin(nx*6.0+ny*2.0)*0.012;
      pos.setZ(i,z);
    }
    g.computeVertexNormals();
    return g;
  }

  function makeSoftShadow(){
    var c=document.createElement('canvas'); c.width=c.height=256;
    var x=c.getContext('2d');
    var g=x.createRadialGradient(128,128,10,128,128,120);
    g.addColorStop(0,'rgba(0,0,0,0.42)'); g.addColorStop(1,'rgba(0,0,0,0)');
    x.fillStyle=g; x.fillRect(0,0,256,256);
    var m=new THREE.Mesh(
      new THREE.PlaneGeometry(4.4,2.0),
      new THREE.MeshBasicMaterial({map:new THREE.CanvasTexture(c),transparent:true,depthWrite:false})
    );
    m.rotation.x=-Math.PI/2; m.position.y=-2.05;
    return m;
  }

  function tryBuild(){
    if(built || !threeReady || !imgReady) return;
    built = true;
    build();
  }

  function build(){
    try{ renderer=new THREE.WebGLRenderer({antialias:true,alpha:true,powerPreference:'low-power'}); }
    catch(e){ return; }
    var w=stage.clientWidth,h=stage.clientHeight;
    renderer.setPixelRatio(Math.min(window.devicePixelRatio||1,1.5));
    renderer.setSize(w,h);
    renderer.outputEncoding=THREE.sRGBEncoding;
    stage.insertBefore(renderer.domElement,stage.firstChild);

    scene=new THREE.Scene();
    camera=new THREE.PerspectiveCamera(30,w/h,0.1,50);
    camera.position.set(0,0.05,7.4);

    scene.add(new THREE.AmbientLight(0xffffff,0.92));
    var d=new THREE.DirectionalLight(0xffffff,0.32); d.position.set(2,2.5,4); scene.add(d);
    var d2=new THREE.DirectionalLight(0xffffff,0.22); d2.position.set(-2,2,-4); scene.add(d2);
    var rim=new THREE.PointLight(0x00fc25,0.5,12); rim.position.set(-3,1,-1.5); scene.add(rim);

    var aspect=baseImg.width/baseImg.height;
    var CW=1024, CH=Math.round(1024/aspect);
    frontComp=document.createElement('canvas'); frontComp.width=CW; frontComp.height=CH; frontCtx=frontComp.getContext('2d');
    backComp=document.createElement('canvas'); backComp.width=CW; backComp.height=CH; backCtx=backComp.getContext('2d');
    frontTex=new THREE.CanvasTexture(frontComp); frontTex.anisotropy=8; frontTex.encoding=THREE.sRGBEncoding;
    backTex=new THREE.CanvasTexture(backComp); backTex.anisotropy=8; backTex.encoding=THREE.sRGBEncoding;

    var sh=3.6, sw=sh*aspect, geo=clothGeometry(sw,sh);
    frontMesh=new THREE.Mesh(geo,new THREE.MeshLambertMaterial({map:frontTex,transparent:true,side:THREE.FrontSide}));
    backMesh=new THREE.Mesh(geo.clone(),new THREE.MeshLambertMaterial({map:backTex,transparent:true,side:THREE.FrontSide}));
    backMesh.rotation.y=Math.PI;

    group=new THREE.Group();
    group.add(frontMesh); group.add(backMesh);
    scene.add(group);
    scene.add(makeSoftShadow());

    setSum('ep3s-cat',CAT_HE[currentCat]||'גברים');
    redraw();
    clock=new THREE.Clock();
    bindInput(); bindVisibility();
    running=true; animate();

    var root=document.getElementById('ep3d');
    if(root) root.classList.add('ep3d-ready');
  }

  function clamp(v,a,b){ return Math.max(a,Math.min(b,v)); }

  function bindInput(){
    var el=renderer.domElement;
    el.addEventListener('pointerdown',function(e){ dragging=true; idle=false; lastPX=e.clientX; lastPY=e.clientY; el.setPointerCapture(e.pointerId); });
    el.addEventListener('pointermove',function(e){
      if(!dragging) return;
      tRotY+=(e.clientX-lastPX)*0.01;
      tRotX=clamp(tRotX+(e.clientY-lastPY)*0.005,-0.35,0.35);
      lastPX=e.clientX; lastPY=e.clientY;
    });
    function up(){ dragging=false; setTimeout(function(){ if(!dragging){ idle=true; } },3000); }
    el.addEventListener('pointerup',up);
    el.addEventListener('pointercancel',up);

    ['ep3d-front','ep3d-back'].forEach(function(id){
      var b=document.getElementById(id); if(!b) return;
      b.addEventListener('click',function(){
        document.querySelectorAll('#ep3d .ep3d-sd').forEach(function(x){x.classList.remove('on');});
        b.classList.add('on');
        var side=b.getAttribute('data-side');
        var base=Math.round(rotY/(Math.PI*2))*(Math.PI*2);
        tRotY=(side==='back')?base+Math.PI:base;
        idle=false;
        setTimeout(function(){ if(!dragging) idle=true; },2600);
      });
    });

    window.addEventListener('resize',function(){
      if(!renderer) return;
      var w=stage.clientWidth,h=stage.clientHeight;
      camera.aspect=w/h; camera.updateProjectionMatrix(); renderer.setSize(w,h);
    });
  }

  function onPick(e){
    var t=e.target;
    if(!t||!t.closest) return;
    var cb=t.closest('.catb');
    if(cb){
      var catKey=cb.getAttribute('data-cat');
      setSum('ep3s-cat', CAT_HE[catKey]||cb.textContent.trim());
      if(catKey) loadShirtForCat(catKey);
    }
    var sz=t.closest('.sz');
    if(sz) setSum('ep3s-size', sz.getAttribute('data-s')||sz.textContent.trim());
  }

  function applyColorFromName(raw){
    if(!raw) return;
    var txt=raw.trim();
    if(!txt) return;
    var m=txt.match(/\(([^)]+)\)/);
    var en=(m?m[1]:txt).toLowerCase().trim();
    var hex=COLOR_MAP[en];
    if(!hex){
      for(var k in COLOR_MAP){ if(en.indexOf(k)>-1){ hex=COLOR_MAP[k]; break; } }
    }
    setSum('ep3s-clr', txt.replace(/\([^)]*\)/,'').replace('צבע נבקר:','').trim()||txt);
    if(hex){ color=hex; if(built) redraw(); }
  }

  function bindWizardSync(){
    document.addEventListener('click', onPick);
    document.addEventListener('touchstart', onPick, {passive:true});

    var cs=document.getElementById('clr-sel');
    if(cs&&'MutationObserver' in window){
      new MutationObserver(function(){ applyColorFromName(cs.textContent); })
        .observe(cs,{childList:true,characterData:true,subtree:true});
    }

    var lbl=document.getElementById('sname-lbl');
    if(lbl&&'MutationObserver' in window){
      new MutationObserver(function(){ setSum('ep3s-shirt', lbl.textContent); })
        .observe(lbl,{childList:true,characterData:true,subtree:true});
    }

    var qn=document.getElementById('qn');
    if(qn&&'MutationObserver' in window){
      new MutationObserver(function(){ setSum('ep3s-qty', qn.textContent); })
        .observe(qn,{childList:true,characterData:true,subtree:true});
    }

    var tx=document.getElementById('tx');
    if(tx) tx.addEventListener('input',function(){ frontText=tx.value.trim(); if(built) redraw(); });
    var tx2=document.getElementById('tx2');
    if(tx2) tx2.addEventListener('input',function(){ backText=tx2.value.trim(); if(built) redraw(); });

    function hookUpload(id,side){
      var uf=document.getElementById(id);
      if(!uf) return;
      uf.addEventListener('change',function(){
        var f=uf.files&&uf.files[0];
        if(!f||f.type.indexOf('image')!==0) return;
        var im=new Image();
        im.onload=function(){
          if(side==='f') frontImg=im; else backImg=im;
          if(built) redraw();
        };
        im.src=URL.createObjectURL(f);
      });
    }
    hookUpload('uf','f');
    hookUpload('uf2','b');
  }

  function bindVisibility(){
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){ visible=en[0].isIntersecting; },{threshold:0.02}).observe(stage);
    }
    document.addEventListener('visibilitychange',function(){ visible=!document.hidden; });
  }

  function animate(){
    if(!running) return;
    requestAnimationFrame(animate);
    if(!visible) return;
    var dt=Math.min(clock.getDelta(),0.05), t=clock.elapsedTime;
    if(idle&&!dragging&&!reduced){
      tRotY+=dt*0.4;
      tRotX=Math.sin(t*0.3)*0.04;
    }
    rotY+=(tRotY-rotY)*0.07;
    rotX+=(tRotX-rotX)*0.07;
    group.rotation.y=rotY;
    group.rotation.x=rotX;
    group.position.y=reduced?0:Math.sin(t*1.1)*0.06;
    renderer.render(scene,camera);
  }

  ready(function(){
    stage=document.getElementById('ep3d-stage');
    if(!stage) return;
    bindWizardSync();

    var _kicked = false;
    function kickHeavyLoad(){
      if(_kicked) return;
      _kicked = true;
      var img=new Image();
      img.crossOrigin='anonymous';
      img.onload=function(){ baseImg=stripShirtBg(downscale(img,900),34); imgReady=true; tryBuild(); };
      img.onerror=function(){ imgReady=false; };
      img.src=SHIRT_URLS[currentCat]||DEFAULT_SHIRT;
      if(window.THREE){ threeReady=true; tryBuild(); }
      else{
        var s=document.createElement('script');
        s.src=THREE_SRC;
        s.async=true;
        s.onload=function(){ threeReady=true; tryBuild(); };
        document.head.appendChild(s);
      }
    }

    var EVS=['pointerdown','touchstart','wheel','scroll','keydown','mousemove'];
    function onFirstInput(){
      EVS.forEach(function(ev){ window.removeEventListener(ev, onFirstInput); });
      kickHeavyLoad();
    }
    EVS.forEach(function(ev){ window.addEventListener(ev, onFirstInput, {passive:true}); });
  });
})();
